import {ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {FormControl, Validators} from "@angular/forms";
import {ApolloQueryObservable} from "apollo-angular";
import {SessionActions} from "../../../shared/actions";
import {MedicineService} from "../../services/medicine.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Stock} from "../../../shared/view-model/stock";
import {Subject} from "rxjs/Subject";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-medicine-stocks-view',
  templateUrl: './medicine-stocks-view.component.html',
  styleUrls: ['./medicine-stocks-view.component.css']
})
export class MedicineStocksViewComponent extends AbstractListView implements OnInit {

  @ViewChild('medicinesTable')
  table: DatatableComponent;

  @ViewChild('actStockTmpl')
  actStockTmpl: TemplateRef<any>;

  @ViewChild('formatDateTimeTmpl')
  formatDateTimeTmpl: TemplateRef<any>;

  @Input()
  showMedicineBookButton: boolean = true;

  messages = {
    emptyMessage: 'Keine Sonderbestände auf der Liste',
    totalMessage: 'Sonderbestände'
  };

  searchTerm: FormControl = new FormControl();
  depotCuid: FormControl = new FormControl(null, Validators.required);
  selectedDepotCuid: Subject<string> = new Subject();

  private medStockList$: ApolloQueryObservable<any>;
  medStockList: Stock[];

  constructor(sessionActions: SessionActions,
              private medService: MedicineService,
              private router: Router, private route: ActivatedRoute,
              cd: ChangeDetectorRef) {

    super(sessionActions, cd);

  }

  ngOnInit() {

    this.isLoading = true;

    this.medStockList$ = this.medService.getMedicineStocks(this.selectedDepotCuid);
    this.addComponentData(this.medStockList$);

    this.dataSubscriptions.push(
      this.medStockList$.subscribe(res => {
        this.medStockList = res.data.medicineStocks;
        this.isLoading = res.loading;
        this.rows = this.medStockList;
      })
    );

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'stock_item.label', name: 'Name', minWidth: 150, flexGrow: 2},
      {
        prop: 'act_stock',
        name: 'Ist-Bestand',
        cellTemplate: this.actStockTmpl,
        minWidth: 60,
        maxWidth: 100,
        flexGrow: 1
      },
      {
        prop: 'updated_at',
        name: 'Zuletzt geändert',
        cellTemplate: this.formatDateTimeTmpl,
        minWidth: 100,
        maxWidth: 150,
        flexGrow: 1
      }
    ];

  }

  onDepotSelected(depot: Depot) {
    this.selectedDepotCuid.next(depot.cuid);
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.medStockList;
    } else {
      if (this.medStockList) {
        this.rows = this.medStockList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {

  }

  showMedicineBookClicked(cuid: string) {
    this.router.navigate(['verbrauch', cuid], {relativeTo: this.route});
  }

  setClasses(stock: Stock) {
    if (!stock) {
      return {};
    }

    let cssClasses = {
      'text-warning': stock.act_stock > stock.min_stock && stock.act_stock <= stock.report_stock,
      'text-danger': stock.act_stock <= stock.min_stock,
      'text-success': stock.act_stock > stock.report_stock,
    };
    return cssClasses;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/medicine/medicine-stocks-view/medicine-stocks-view.component.ts